import moment from 'moment'

export default {

    formatDate(row, column, cellValue, index) {
        if (cellValue == undefined) {
            return "";
        }

        if (cellValue.length === 8) {
            return moment(cellValue, "YYYYMMDD").format("YYYY-MM-DD");
        }

        if (cellValue.length === 6) {
            return moment(cellValue, "HHmmss").format("HH:mm:ss");
        }
        if (cellValue.length === 14) {
            return moment(cellValue, "YYYYMMDDHHmmss").format("YYYY-MM-DD HH:mm:ss");
        }

        return moment(cellValue, "x").format("YYYY-MM-DD HH:mm:ss")


    },

    formatBoolean(row, column, cellValue, index) {
        return cellValue ? "是" : "否";
    },

    /**
     * 格式化认证状态
     * @param row
     * @param column
     * @param cellValue
     * @param index
     * @returns {string}
     */
    formatAuthStatus(row, column, cellValue, index) {
        if (cellValue === "000") {
            return "认证一致";
        } else if (cellValue === "042") {
            return "认证不一致";
        } else if (cellValue === "043") {
            return "认证受限";
        } else if (cellValue === "801") {
            return "认证失败";
        } else if (cellValue === "999") {
            return "交易失败";
        }
    },

    /**
     * 分转元
     * @param row
     * @param column
     * @param cellValue
     * @param index
     * @returns {string}
     */
    FenToYuan(row, column, cellValue, index) {
        if (!cellValue) {
            return "";
        }
        const item = (cellValue / 100).toFixed(5);
        const regexp=/(?:\.0*|(\.\d+?)0+)$/
        return item.replace(regexp,'$1')
    },


    YuanToFen(row, column, cellValue, index) {
        if (cellValue === null || cellValue === undefined) {
            return "";
        }
        return (cellValue / 100).toFixed(2);
    },

    formatMerState(row, column, cellValue, index) {
        if (cellValue === "00") {
            return "开通";
        } else if (cellValue === "01") {
            return "关闭";
        }
    },

    formatProdStatus(row, column, cellValue, index) {
        if (cellValue === "00") {
            return "测试对接中";
        } else if (cellValue === "01") {
            return "申请上线中";
        } else if (cellValue === "02") {
            return "正式运行中";
        }
    },

    formatCommonStatus(row, column, cellValue, index) {
        if (cellValue === "00") {
            return "禁用";
        } else if (cellValue === "01") {
            return "正常";
        }
    },


    formatRouteStatus(row, column, cellValue, index) {
        if (cellValue === "00") {
            return "关闭";
        } else if (cellValue === "01") {
            return "开通";
        }
    },

    formatOrderStatus(row, column, cellValue, index) {
        if (cellValue === "00") {
            return "支付中";
        } else if (cellValue === "01") {
            return "支付成功";
        }
        else if (cellValue === "02") {
            return "支付失败";
        }
        else if (cellValue === "03") {
            return "超时取消";
        }
        else if (cellValue === "04") {
            return "交易退款";
        }
        else if (cellValue === "99") {
            return "待提交";
        }
        else if (cellValue === "06") {
            return "待确认";
        }
        else if (cellValue === "90") {
            return "待扣款";
        }
    },

    formatCallBackStatus(row, column, cellValue, index) {
        if (cellValue === "00") {
            return "未回调";
        } else if (cellValue === "01") {
            return "回调成功";
        } else {
            return "回调失败";
        }
    },

    formatMerPayTypeStatus(row, column, cellValue, index) {
        const depositStatus = row.depositStatus;
        const withdrawStatus = row.withdrawStatus;

        if (depositStatus === "01" && withdrawStatus === '01') {
            return "正常";
        } else if (depositStatus === "01" && withdrawStatus === '00') {
            return "仅代收";
        } else if (depositStatus === "00" && withdrawStatus === '01') {
            return "仅代付";
        } else {
            return "禁用";
        }
    },

    formatYesNo(row, column, cellValue, index) {
        if (cellValue === '00') {
            return "否";
        } else if (cellValue === "01") {
            return "是";
        } else {
            return "";
        }
    },

    formatSettlementStatus(row, column, cellValue, index) {
        if (cellValue === "00") {
            return "未结算";
        } else if (cellValue === "01") {
            return "已结算";
        } else {
            return "其他";
        }
    },

    formatFreezeStatus(row, column, cellValue, index) {
        if (cellValue === "01") {
            return "已冻结";
        } else if (cellValue === "00") {
            return "已解冻";
        } else if (cellValue === "02") {
            return "已退款";
        } else {
            return "未冻结";
        }
    },

    formatTieredBilling(row, column, cellValue, index) {
        if (cellValue === "00") {
            return "关闭";
        } else if (cellValue === "01") {
            return "开启";
        } else {
            return "其他";
        }
    },

    formatNotifyV2(row, column, cellValue, index) {
        if (cellValue === "00") {
            return "V1";
        } else if (cellValue === "01") {
            return "V2";
        } else {
            return "未知";
        }
    },

    formatPayType(row, column, cellValue, index) {
        if (cellValue === "01") {
            return "razorpay";
        } else if (cellValue === "02") {
            return "honghuapayout";
        } else if (cellValue === "03") {
            return "honghuapay";
        } else if (cellValue === "04") {
            return "cashfreepay";
        } else if (cellValue === "05") {
            return "flyfishpay";
        } else if (cellValue === "06") {
            return "flyfishpayout";
        } else if (cellValue === "99") {
            return "代付";
        }
    },

    formatChannelType(row, column, cellValue, index) {
        if (cellValue === "01") {
            return "razorpay";
        } else if (cellValue === "02") {
            return "honghuapayout";
        } else if (cellValue === "03") {
            return "honghuapay";
        } else if (cellValue === "04") {
            return "cashfreepay";
        } else if (cellValue === "05") {
            return "flyfishpay";
        } else if (cellValue === "06") {
            return "flyfishpayout";
        } else if (cellValue === "99") {
            return "代付";
        }
    },

    formatDeviceType(row, column, cellValue, index) {
        if (cellValue === "01") {
            return "湖南农信银";
        }
    },

    formatBelongType(row, column, cellValue, index) {
        if (cellValue === "01") {
            return "平台";
        } else if (cellValue === "02") {
            return "代理商";
        } else if (cellValue === "03") {
            return "商户";
        }
    },

    formatWithdrawStatus(row, column, cellValue, index) {
        if (cellValue === "00") {
            return "处理中";
        } else if (cellValue === "01") {
            return "提现成功";
        } else if (cellValue === "02") {
            return "提现失败";
        } else if (cellValue === "03") {
            return "驳回";
        } else if (cellValue === "04") {
            return "出款中";
        }
    },

    formatRechargeStatus(row, column, cellValue, index) {
        if (cellValue === "00") {
            return "处理中";
        } else if (cellValue === "01") {
            return "充值成功";
        } else if (cellValue === "02") {
            return "充值失败";
        } else if (cellValue === "03") {
            return "驳回";
        } else if (cellValue === "04") {
            return "出款中";
        }
    },
    formatApprovalStatus(row, column, cellValue, index) {
        if (cellValue === "00") {
            return "待审核";
        } else if (cellValue === "01") {
            return "已通过";
        } else if (cellValue === "02") {
            return "已拒绝";
        }
    },
    formatTransType(row, column, cellValue, index) {
        if (cellValue === "11") {
            return "代收成功";
        } else if (cellValue === "10") {
            return "代收退款";
        } else if (cellValue === "21") {
            return "代付退款";
        } else if (cellValue === "22") {
            return "代付失败";
        } else if (cellValue === "20") {
            return "代付发起";
        } else if (cellValue === "31") {
            return "充值成功";
        } else if (cellValue === "30") {
            return "提现成功";
        } else if (cellValue === "40") {
            return "上线清零";
        } else if (cellValue === "50") {
            return "代理结算";
        } else if (cellValue === "51") {
            return "代理提现";
        } else if (cellValue === "61") {
            return "冲正扣减";
        } else if (cellValue === "62") {
            return "冲正增加";
        }
    },

    formatWithdrawType(row, column, cellValue, index) {
        if (cellValue === "01") {
            return "商户提现";
        } else if (cellValue === "02") {
            return "代理商提现";
        }
    },

    formatApprovalStatus(row, column, cellValue, index) {
        if (cellValue === "00") {
            return "待审核";
        } else if (cellValue === "01") {
            return "审核通过";
        } else {
            return '审核拒绝'
        }
    },

    formatStatiscsBankType(row, column, cellValue, index) {
        if (cellValue === "payInSuccess") {
            return "代收成功";
        } else if (cellValue === "payOutSuccess") {
            return "代付成功";
        } else {
            return '代付异常'
        }
    },

}